import Vue from 'vue/dist/vue.esm.js'
import draggable from 'vuedraggable'

KCVS.Views.ReportFileGroupTable = Vue.extend(
  template: JST['report_file_groups/report_file_group_table'](),
  name: 'report-file-group-table'
  props: ['group', 'pprpId', 'reportFiles', 'collection']
  data: ->
    sortGroup: { name: 'report-file-group', animation: 150, pull: true, put: true }
    list: @reportFiles
    loading: false
    draggingFileId: null

  created: ->
    EventBus.$on 'file-dropped-on-group-header', (groupId, fileId) =>
      @updateReportFileGroup(fileId, groupId)
      EventBus.$emit('refetch-all-groups')

    EventBus.$on 'group-changed', (newGroupId, oldGroupId, fileId) =>
      @updateReportFileGroup(fileId, newGroupId)
      @.$nextTick =>
        EventBus.$emit('update-files-after-group-change', newGroupId, oldGroupId)
  methods:
    truncateText: (text, length) ->
      if text.length > length
        text.substring(0, length) + '...';
      else
        text

    translateText: (text) ->
      I18n.t(text)

    dynamicFilePath: (fileId, action) ->
      "/project_partner_report_periods/#{@pprpId}/report_files/#{fileId}/#{action}"

    destroyReportFile: (fileId, groupId) ->
      AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content')
      $.ajax
        url: "/project_partner_report_periods/#{@pprpId}/report_files/#{fileId}"
        method: 'DELETE'
        data: {
          authenticity_token: AUTH_TOKEN
        }
        success: (response) =>
          @$emit('file-deleted', groupId)

    reportFilesPresent: (files) ->
      files && files.length > 0

    updateReportFileGroup: (fileId, newGroupId) ->
      if newGroupId
        AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content')
        $.ajax
          url: "/project_partner_report_periods/#{@pprpId}/report_files/#{fileId}/update_group"
          method: 'PUT'
          data:
            authenticity_token: AUTH_TOKEN
            report_file: { report_file_group_id: newGroupId }
          success: (response) =>
            @$emit('file-group-updated')

    onDragStart: (event) ->
      @draggingFileId = event.clone.getAttribute('data-file-id')
      EventBus.$emit('dragging-file-started', @draggingFileId, @group.id)

    onDragEnd: (event) ->
      movedItemId = event.item.dataset.fileId
      newGroupId = event.to.dataset.groupId
      oldGroupId = event.from.dataset.groupId
      if newGroupId != oldGroupId
        @updateReportFileGroup(movedItemId, newGroupId)

    quickFilePreview: (event, file) ->
      element = $(event.currentTarget)
      attr = element.attr('aria-describedby')
      unless (typeof attr != typeof undefined && attr != false)
        if (element.parent().hasClass('pdf') || element.parent().hasClass('png') || element.parent().hasClass('jpg'))
          element.off 'hover'
          iframeContent = @fetchFileIframe(file.id)
          $.get element.data('popload'), (data) ->
            element.popover(content: iframeContent.responseText, html: true, container: element, sanitize: false).popover 'show'
            return

    closeFilePreview: (event) ->
      $('[data-original-title]').popover 'hide'

    fetchFileIframe: (fileId) ->
      $.ajax
        url: "/file_previews/#{fileId}/report_file"
        method: 'GET'
        dataType: 'html'
        success: (response) =>
          return response

  components:
    draggable: draggable
    GroupSelect: KCVS.Views.ReportFileGroupSelect
)
